import { ProgressDots } from "@faire/deprecated-retailer-visitor-shared/components/MobileSlider/ProgressDots";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import React, { useRef, useState } from "react";
import Slider, { Settings as SliderProps } from "react-slick";

type Props = Omit<SliderProps, "ref"> & {
  children?: React.ReactNode | undefined;
  numberOfSlides: number;
};

export const MobileSlider: React.FC<Props> = ({
  numberOfSlides,
  children,
  ...props
}) => {
  const ref = useRef<Slider | null>(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  const beforeChange = (currentIndex: number, newIndex: number) => {
    setCurrentIndex(newIndex);
    props.beforeChange?.(currentIndex, newIndex);
  };

  return (
    <>
      <Slider {...props} ref={ref} beforeChange={beforeChange}>
        {children}
      </Slider>
      <Spacer size="1x" />
      <Column align="center">
        <ProgressDots progress={currentIndex} total={numberOfSlides} />
      </Column>
      <Spacer size="2x" />
    </>
  );
};
